<template >
  <div class="search-helper-comp__table--operator search-helper-table">
    <div :class="{'search-helper-table__current': currentNav === hrefLogicConnector.nav}">
      <div
        class="search-helper-table__title"
        :id="hrefLogicConnector.id"
      >{{hrefLogicConnector.label}}</div>
      <table class="splitThreeTds">
        <thead>
          <tr>
            <td>{{$t('searchHelper["Operator"]')}}</td>
            <td>{{$t('searchHelper["Usage & Function"]')}}</td>
            <td>{{$t('searchHelper["Examples"]')}}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>AND</td>
            <td>
              <p>{{$t('searchHelper["Retrieves patents containing all matching keywords/criteria."]')}}</p>
              <p>{{$t('searchHelper["AND Either keyword/criteria may appear first."]')}}</p>
              <p>{{$t('searchHelper.logicalOperatorsIsIncreasedByAnd')}}</p>
            </td>
            <td>
              <p>{{$t('searchHelper["solar AND cell"]')}}</p>
              <p>{{$t('searchHelper["TTL:computer AND AN:apple"]')}}<br /></p>
            </td>
          </tr>
          <tr>
            <td>OR</td>
            <td>
              <p>{{$t('searchHelper["Retrieves patents containing either keyword/criteria."]')}}</p>
              <p>{{$t('searchHelper["Either keyword/criteria may appear first."]')}}</p>
            </td>
            <td>
              <p>{{$t('searchHelper["battery OR cell"]')}}</p>
              <p>{{$t('searchHelper["TTL:computer OR IPC: H01L"]')}}</p>
            </td>
          </tr>
          <tr>
            <td>NOT</td>
            <td>
              <p>{{$t('searchHelper["Retrieves patents containing the first keyword/criteria, but not containing the second keyword/criteria."]')}}</p>
              <p v-if="language === 'cn' || language === 'de'">{{$t('searchHelper["Retrieves patents EG2"]')}}</p>
              <p>{{$t('searchHelper.logicalOperatorsIsIncreasedByAdding')}}</p>
            </td>
            <td>
              <p>{{$t('searchHelper["battery NOT lead-acid"]')}}</p>
              <p>{{$t('searchHelper["AN:apple NOT ABST:screen"]')}}</p>
            </td>
          </tr>
          <tr>
            <td>GAND</td>
            <td>
              <p>{{$t('searchHelper.GAND.tip1')}}</p>
              <p>{{$t('searchHelper.GAND.tip2')}}</p>
              <p v-html="$t('searchHelper.GAND.tip3')"></p>
            </td>
            <td>
              <p>{{$t('searchHelper.GAND.exampleCode1')}}</p>
              <p>{{$t('searchHelper.GAND.exampleCode2')}}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div :class="{'search-helper-table__current': currentNav === hrefWildcards.nav}">
      <div
        class="search-helper-table__title"
        :id="hrefWildcards.id"
      >{{hrefWildcards.label}}</div>
      <table class="splitThreeTds">
        <thead>
          <tr>
            <td>{{$t('searchHelper["Operator"]')}}</td>
            <td>{{$t('searchHelper["Usage & Function"]')}}</td>
            <td>{{$t('searchHelper["Examples"]')}}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>*</td>
            <td>
              <p>{{$t('searchHelper["A wildcard that can be used to replace a string of characters at the end or in the middle of a word. "]')}}</p>
              <p>{{$t('searchHelper["canBeUsedUpToTwoTimes"]')}}</p>
              <p>{{$t('searchHelper["canBeUsedInBothText"]')}}</p>
              <p>{{$t('searchHelper["canBeUsedWithinTitle"]')}}</p>
              <p>{{$t('searchHelper["mustBeAtLeastThree"]')}}</p>
              <p>{{$t('searchHelper["Should be used with keyword stemming turned OFF."]')}}</p>
              <p v-if="$t('searchHelper.notAvailableWithinQuotation')">{{$t('searchHelper.notAvailableWithinQuotation')}}</p>
            </td>
            <td>
              <p>*otor</p>
              <p>*oto*</p>
              <p>electr*</p>
              <p>EP200*B2</p>
            </td>
          </tr>
          <tr>
            <td>?</td>
            <td>
              <p v-html="$t('searchHelper.question_mark')"></p>
              <!-- <p v-if="language=== 'en'">Can be used multiple times.</p> -->
            </td>
            <td>
              <p>?otor</p>
              <p>gra???ne</p>
              <p>US7654???</p>
              <p v-if="language !== 'jp' && language !== 'en'">小??车</p>
            </td>
          </tr>
          <tr>
            <td>#</td>
            <td>
              <p v-html="$t('searchHelper.sharp')"></p>
            </td>
            <td>
              <p>#otor</p>
              <p>m#tor</p>
              <p>moto#</p>
              <p v-if="language !== 'jp' && language !== 'en'">小#车</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>


    <template v-if="!isRDUser">
    <div :class="{'search-helper-table__current': currentNav === hrefPositionConnector.nav}">
      <div
        class="search-helper-table__title"
        :id="hrefPositionConnector.id"
      >{{hrefPositionConnector.label}}</div>
      <table class="splitThreeTds">
        <thead>
          <tr>
            <td>{{$t('searchHelper["Operator"]')}}</td>
            <td>{{$t('searchHelper["Usage & Function"]')}}</td>
            <td>{{$t('searchHelper["Examples"]')}}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>$Wn</td>
            <td>
              <p v-html="$t('searchHelper.$Wn')"></p>
            </td>
            <td>
              <p>{{$t('searchHelper["data $W2 line"]')}}</p>
              <p>{{$t('searchHelper["ABST:(solar cell $W5 silicon)"]')}}</p>
            </td>
          </tr>
          <tr>
            <td>$PREn</td>
            <td>
              <p v-html="$t('searchHelper.$PREn')"></p>
            </td>
            <td>
              <p>{{$t('searchHelper["data $PRE2 line"]')}}</p>
              <p>{{$t('searchHelper["ABST:(solar cell $PRE5 silicon)"]')}}</p>
            </td>
          </tr>
          <tr>
            <td>$WS</td>
            <td>
              <p>{{$t('searchHelper.keywordsOperator')}}</p>
              <p>{{$t('searchHelper.positionConnectorHasHighPriority')}}</p>
            </td>
            <td>
              <p>{{$t('searchHelper["display $WS HDMI"]')}}</p>
              <p>{{$t('searchHelper["ABST:(display $WS screen $WS HDMI)"]')}}</p>
            </td>
          </tr>

          <tr>
            <td>$SEN</td>
            <td>
              <p>{{$t('searchHelper.senFunction')}}</p>
              <p>{{$t('searchHelper.positionConnectorHasHighPriority')}}</p>
            </td>
            <td>
              <p>CLMS:(data $SEN line)</p>
              <p>{{$t('searchHelper.senDemo')}}</p>
            </td>
          </tr>
          <tr>
            <td>$PARA</td>
            <td>
              <p>{{$t('searchHelper.paraFunction')}}</p>
              <p>{{$t('searchHelper.positionConnectorHasHighPriority')}}</p>
            </td>
            <td>
              <p>DESC:(data $PARA line)</p>
              <p>{{$t('searchHelper.paraDemo')}}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>


    <div :class="{'search-helper-table__current': currentNav === hrefFrequencyConnector.nav}">
      <div
        class="search-helper-table__title"
        :id="hrefFrequencyConnector.id"
      >{{hrefFrequencyConnector.label}}</div>
      <table class="splitThreeTds">
        <thead>
          <tr>
            <td>{{$t('searchHelper["Operator"]')}}</td>
            <td>{{$t('searchHelper["Usage & Function"]')}}</td>
            <td>{{$t('searchHelper["Examples"]')}}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>$FREQn</td>
            <td>
                  <div v-html="$t('searchHelper.frequencyFunction')" />
            </td>
            <td>
              <div v-html="$t('searchHelper.frequencyDemo')" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </template>


    <div :class="{'search-helper-table__current': currentNav === hrefOthers.nav}">
      <div
        class="search-helper-table__title"
        :id="hrefOthers.id"
      >{{hrefOthers.label}}</div>
      <table class="splitThreeTds">
        <thead>
          <tr>
            <td>{{$t('searchHelper["Operator"]')}}</td>
            <td>{{$t('searchHelper["Usage & Function"]')}}</td>
            <td>{{$t('searchHelper["Examples"]')}}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>()</td>
            <td>
              {{$t('searchHelper["Parentheses can be used to define the order in which the system combines parts of your search."]')}}
            </td>
            <td>
              <p>{{$t('searchHelper["vehicle AND (engine OR motor)"]')}}</p>
            </td>
          </tr>
          <tr>
            <td>[]</td>
            <td>
              <p>{{$t('searchHelper["Square brackets should be used in date range queries."]')}}</p>
            </td>
            <td>
                PBD:[20010101 TO 20101231]<br>
                IPC:[H01L31/0203 TO H01L31/042]
            </td>
          </tr>
          <tr>
            <td>""</td>
            <td>
              <p>{{$t('searchHelper["Keywords within quotation marks should appear next to each other, in the order specified."]')}}</p>
              <p>{{$t('searchHelper.phraseQueryFix')}}</p>
            </td>
            <td>
              <p>"electric vehicle"</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>_</p>
              <p>{{ $t('searchHelper.optionalAelimiter.title') }}</p>
            </td>
            <td>
              <p>{{ $t('searchHelper.optionalAelimiter.desc1') }}</p>
              <p>{{ $t('searchHelper.optionalAelimiter.desc2') }}</p>
              <p>{{ $t('searchHelper.optionalAelimiter.desc3') }}</p>
            </td>
            <td>
              <p>{{ $t('searchHelper.optionalAelimiter.example') }}</p>
            </td>
          </tr>
          <tr>
            <td>{{$t('searchHelper["Stemming"]')}}</td>
            <td>
              <p>{{$t('searchHelper["With stemming ON, patents in your search results would contain either the root word, or possible suffixes of the root word."]')}}</p>
              <p>{{$t('searchHelper["With stemming OFF, your search is limited to the single or plural form of the search word."]')}}</p>
              <p>{{$t('searchHelper["will impact the effect of stemming"]')}}</p>
              <p>{{$t('searchHelper.stemmingOnlySupports')}}</p>
            </td>
            <td>
              <p v-if="language==='en'">TTL:come</p>
              <p>{{$t('searchHelper["TTL:electric EG1"]')}}</p>
              <p>{{$t('searchHelper["TTL:electric EG2"]')}}</p>
            </td>
          </tr>
          <tr>
              <td>TREE@</td>
              <td>
                  <p>{{$t('searchHelper["treeKeywordTip"]')}}</p>
              </td>
              <td>
                  <p>{{$t('searchHelper["treeKeywordExample"]')}}</p>
              </td>
          </tr>
          <tr>
              <td>{{$t('searchHelper.specialWord')}}</td>
              <td>
                  <p v-html="$t('searchHelper.specialWordTip')"></p>
              </td>
              <td>
                  <p>{{$t('searchHelper.specialWordExample')}}</p>
              </td>
          </tr>
          <!-- <tr>
              <td>R</td>
              <td>
                  <p v-html="$t('searchHelper.semanticRankingTip')"></p>
              </td>
              <td>
                  <p>{{$t('searchHelper.semanticRankingExample')}}</p>
              </td>
          </tr> -->
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import { get, map, remove } from 'lodash';

const config = [
    {
        id: 'hrefLogicConnector',
        i18nKey: 'searchHelper["Logic Connector"]'
    },
    {
        id: 'hrefWildcards',
        i18nKey: 'searchHelper["Wildcards"]'
    },
    {
        id: 'hrefPositionConnector',
        i18nKey: 'searchHelper["Position Connector"]'
    },
    {
        id: 'hrefFrequencyConnector',
        i18nKey: 'searchHelper["frequencyConnector"]'
    },
    {
        id: 'hrefOthers',
        i18nKey: 'searchHelper["Others"]'
    }
];

export default {
    props: {
        currentNav: String
    },
    data() {
        const navList = map(config, item => {
            return {
                ...item,
                nav: `#${item.id}`,
                label: this.$t(item.i18nKey)
            };
        });
        this.isRDUser = get(window, 'zPREFACE.accountInfo.rd_user', false);
        if (this.isRDUser) {
            remove(navList, (nav)=>{
                return ['hrefPositionConnector', 'hrefFrequencyConnector'].includes(nav.id);
            });
        }
        return {
            language: this.$i18n.locale,
            navList
        };
    },
    computed: {
        hrefLogicConnector() {
            return this.navList[0];
        },
        hrefWildcards() {
            return this.navList[1];
        },
        hrefPositionConnector() {
            return this.isRDUser ? null : this.navList[2];
        },
        hrefFrequencyConnector() {
            return this.isRDUser ? null : this.navList[3];
        },
        hrefOthers() {
            return this.isRDUser ? this.navList[2] : this.navList[4];
        }
    },
    mounted() {
        this.$emit('update-nav-handler', this.navList);
    }
};
</script>
<style lang="scss">
</style>
